import { createAsyncThunk } from "@reduxjs/toolkit"

import { allUsers, gameConfig } from "src/store/common"

export const loadCommonData = createAsyncThunk("auth/loadCommonData", async (_, { dispatch, rejectWithValue }) => {
  try {
    return await Promise.all([dispatch(allUsers()), dispatch(gameConfig())])
  } catch (error) {
    return rejectWithValue(error)
  }
})
